/* Mochi Cloud - desktop gallery slider + thumbnail strip.
   Horizon re-renders <media-gallery> on every variant change, which wipes the
   thumbnail bar and the wiring. So this rebuilds itself whenever the gallery
   node or its track is replaced, instead of running once on load. */
(function () {
  var wiredTrack = null;

  function build() {
    var gal = document.querySelector('media-gallery');
    if (!gal) return;
    var track = gal.querySelector('.media-gallery__grid');
    if (!track) return;

    var bar = gal.querySelector('.pd-thumbs');
    if (track === wiredTrack && bar && bar.isConnected) return;

    var slides = [].slice.call(track.children);
    if (slides.length < 2) { if (bar) bar.remove(); wiredTrack = track; return; }

    if (bar) bar.remove();
    gal.classList.add('pd-gal');

    bar = document.createElement('div');
    bar.className = 'pd pd-thumbs';

    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      [].forEach.call(bar.children, function (b, n) { b.classList.toggle('is-on', n === i); });
    }

    slides.forEach(function (s, i) {
      var img = s.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
      if (img) {
        var t = document.createElement('img');
        t.src = img.currentSrc || img.src;
        t.alt = '';
        t.loading = 'lazy';
        b.appendChild(t);
      }
      b.addEventListener('click', function () {
        var prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = s.offsetLeft - slides[0].offsetLeft;
        track.style.scrollBehavior = prev;
        sync();
      });
      bar.appendChild(b);
    });

    gal.appendChild(bar);
    track.addEventListener('scroll', sync, { passive: true });
    sync();
    wiredTrack = track;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  var pending = null;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(build, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('pageshow', build);
  setTimeout(build, 900);
  setTimeout(build, 2000);
})();
